/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_ProviderInputs */

const en_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription Provider`)
};

const fr_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestataire de transcription`)
};

const de_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkriptionsanbieter`)
};

const it_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornitore di trascrizioni`)
};

const ru_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик услуг транскрипции`)
};

const es_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor de transcripción`)
};

const zh_cn2_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录服务提供商`)
};

const ja_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字起こしサービス提供業者`)
};

const hi_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेखन प्रदाता`)
};

const pt_pt2_transcription_provider = /** @type {(inputs: Transcription_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornecedor de transcrição`)
};

/**
* | output |
* | --- |
* | "Transcription Provider" |
*
* @param {Transcription_ProviderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_provider = /** @type {((inputs?: Transcription_ProviderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_ProviderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcription_provider(inputs)
	if (locale === "de") return de_transcription_provider(inputs)
	if (locale === "it") return it_transcription_provider(inputs)
	if (locale === "ru") return ru_transcription_provider(inputs)
	if (locale === "es") return es_transcription_provider(inputs)
	if (locale === "zh-CN") return zh_cn2_transcription_provider(inputs)
	if (locale === "ja") return ja_transcription_provider(inputs)
	if (locale === "hi") return hi_transcription_provider(inputs)
	if (locale === "pt-PT") return pt_pt2_transcription_provider(inputs)
	return en_transcription_provider(inputs)
});